import styled from 'styled-components';

export const PageTypographyScope = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;

export const DashboardStatCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 12px;
  padding: 10px 14px 8px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  min-width: 118px;
  min-height: 92px;
  box-sizing: border-box;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.15s;

  &:hover {
    background: ${({ theme }) => theme.colors.bgSecundario};
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.primarySoftBorder};
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 100%;
    font-size: 20px;
    line-height: 1;
    margin-bottom: 2px;
  }

  .label {
    font-size: 10px;
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    opacity: 0.78;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    min-height: 14px;
  }

  .value {
    font-size: 18px;
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    line-height: 1;
    min-height: 22px;
  }
`;

export const UnifiedStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 6px;
  border-left: 4px solid
    ${({ $tone, theme }) => {
      if ($tone === 'danger') return theme.colors.danger;
      if ($tone === 'warning') return theme.colors.warning;
      if ($tone === 'info') return theme.colors.info;
      if ($tone === 'success') return theme.colors.success;
      // Trío dedicado (violetaBg/Txt/Border), no `accent` a secas: accent
      // (#6f42c1) es un violeta saturado pensado para fondos sólidos, sin
      // contraste suficiente como texto sobre un fondo translúcido oscuro.
      // violetaTxt sí está calibrado para eso (mismo trío que usa Almacén
      // para el sello "Devolución").
      if ($tone === 'violeta') return theme.colors.violetaBorder;
      return theme.colors.secondary;
    }};
  color: ${({ $tone, theme }) => {
    if ($tone === 'danger') return theme.colors.danger;
    if ($tone === 'warning') return theme.colors.warning;
    if ($tone === 'info') return theme.colors.info;
    if ($tone === 'success') return theme.colors.success;
    if ($tone === 'violeta') return theme.colors.violetaTxt;
    return theme.colors.txtPrincipal;
  }};
  background: ${({ $tone, theme }) => {
    if ($tone === 'danger') return theme.colors.dangerAlpha;
    if ($tone === 'warning') return theme.colors.warningAlpha;
    if ($tone === 'info') return theme.colors.infoAlpha;
    if ($tone === 'success') return theme.colors.successAlpha;
    if ($tone === 'violeta') return theme.colors.violetaBg;
    return theme.colors.neutroAlpha;
  }};
`;

export const StickyActionsBar = styled.div`
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.sticky};
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding: 6px 0;
  background: ${({ theme }) => theme.colors.bgPrincipal};
`;

export const statusToneFromMaintenanceLevel = (level) => {
  if (level === 'excedido') return 'danger';
  if (level === 'urgente') return 'warning';
  if (level === 'proximo') return 'info';
  if (level === 'normal') return 'success';
  return 'neutral';
};
